import React from "react";
import ListItem from "@material-ui/core/ListItem";

import ListItemIcon from "@material-ui/core/ListItemIcon";

import ListItemText from "@material-ui/core/ListItemText";
import DescriptionIcon from "@material-ui/icons/Description";
import Link from "@material-ui/core/Link";
import { IDocument } from "../types";
interface Props {
  document: IDocument;
}

const DocumentItem: React.FC<Props> = ({ document }) => {
  return (
    <>
      <ListItemIcon>
        <DescriptionIcon />
      </ListItemIcon>

      <ListItemText>
        <Link href={document.Path} target="_blank" rel="noopener noreferrer">
          {document.FriendlyName || document.Name}
        </Link>
      </ListItemText>
    </>
  );
};

export default React.memo(DocumentItem);
